import { render, staticRenderFns } from "./brigad.vue?vue&type=template&id=705bbcb6&"
import script from "./brigad.vue?vue&type=script&lang=js&"
export * from "./brigad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports